import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination, TableItemsQuestions } from "../../components";
import AddModalQuestions from "../Modals/AddModalQuestions";
import { closeModal } from "../../store/slices/deleteModalSlice";
import {
  fetchDataQuestions,
  setPage,
} from "../../store/slices/apiQuestionSlice";
import "react-toastify/dist/ReactToastify.css";
import TableItemsQuestionsResponsive from "../TableItemsQuestions/TableItemsQuestionsResponsive";

const TableQuestions = () => {
  const dispatch = useDispatch();

  const backendBaseUrl = "https://back2.autoshkollaime.com";
  const dataQuestions = useSelector((state) => state.apiQuestion.data);
  const currentPage = useSelector((state) => state.apiQuestion.currentPage);
  const totalCount = useSelector((state) => state.apiQuestion.totalCount);

  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");

  useEffect(() => {
    const pageToUse = prevSearchRef.current !== searchInput ? 1 : currentPage;

    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }

    dispatch(fetchDataQuestions({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Optional if you want explicit submit:
    dispatch(setPage(1));
    dispatch(fetchDataQuestions({ page: 1, searchQuery: searchInput }));
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };
  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900 gap-3 sm:gap-0">
        <div className="flex-1 w-full sm:w-auto">
          <SearchBar
            searchInput={searchInput}
            handleSearchInputChange={handleSearchInputChange}
            handleSearchSubmit={handleSearchSubmit}
          />
        </div>
        <div>
          <button className="text-blue-500 mx-2 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded">
            <AddModalQuestions
              title="Shto një pyetje"
              submitButtonText="Shto pyetjen"
              onCancel={handleCloseModal}
              exams="Zgjedh testin"
              questionsCategory="Zgjedh pyetjen me kategori"
              questionsAnswer1="Shkruaj pergjigjet"
              questionsAnswer2="Saktë"
              questionsAnswer3="Shkruaj pergjigjen e 3"
              score="Piket"
            />
          </button>
        </div>
      </div>

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="w-full min-w-[600px] text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Pyetja
                </th>
                <th scope="col" className="px-6 py-3">
                  Testi
                </th>
                <th scope="col" className="px-6 py-3 whitespace-nowrap">
                  Kategoria e Testit
                </th>
                <th scope="col" className="px-6 py-3">
                  Pikët
                </th>
                <th scope="col" className="px-6 py-3">
                  Foto
                </th>
                <th scope="col" className="px-6 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsQuestions
                dataQuestions={dataQuestions}
                baseUrl={backendBaseUrl}
              />
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          <TableItemsQuestionsResponsive
            dataQuestions={dataQuestions}
            baseUrl={backendBaseUrl}
          />
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableQuestions;
